import React from "react";
import { Link } from "react-router-dom";
import { AllCommunityService } from "../FetchAPI";

export default function ComunityServiceBox({ RendomTokenfetch, CatID }) {
  const [AllserviceCat] = AllCommunityService(RendomTokenfetch, CatID);
  // console.log(AllserviceCat);

  return (
    <>
      {AllserviceCat &&
        AllserviceCat.map((SerValue, index) => (
          <li className="col-sm-12 col-lg-4 col-md-6 formdataLI" key={index}>
            <Link
              to={`/${SerValue.service_catslug}/${SerValue.slug}`}
              className="formDatalink"
            >
              {SerValue.community_service}
            </Link>
          </li>
        ))}
    </>
  );
}
